﻿import { FIQAssist  } from "../app";
import { Component, Input, Output, Attribute, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'section',
    transclude: false,
    template: `<div class="container">
    <div class="header">
         <div>This is the header whose height is unknown</div>
        <textarea></textarea>
    </div>
    <div class="body">
        <div class="outer-wrapper">
            <div class="inner-wrapper">
                <div class="content-wrapper">
                    <div>This is the scrollable content whose height is unknown</div>
                    <div>This is the scrollable content whose height is unknown</div>
                    <div>This is the scrollable content whose height is unknown</div>
                    <div>This is the scrollable content whose height is unknown</div>
                </div>
            </div>
        </div>
    </div>
       <div class="table-row header">
         <div>This is the header whose height is unknown</div>
        <textarea></textarea>
    </div>
</div>`
})
export class Section {

    private _element: angular.IRootElementService;
    private _transclude: angular.ITranscludeFunction;

    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$transclude') $transclude: angular.ITranscludeFunction
    ) {
        //this._element = $element;
        //this._transclude = $transclude;
        //this.initTransclude(this._transclude, this._element);
    }

    initTransclude(transclude: angular.ITranscludeFunction, element: angular.IRootElementService) {
        transclude((e, s) =>
            element.children().append(e));
    }

}